import { render, staticRenderFns } from "./ShareOfShelf.vue?vue&type=template&id=55737a29&scoped=true"
import script from "./ShareOfShelf.vue?vue&type=script&lang=js"
export * from "./ShareOfShelf.vue?vue&type=script&lang=js"
import style0 from "./ShareOfShelf.vue?vue&type=style&index=0&id=55737a29&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55737a29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55737a29')) {
      api.createRecord('55737a29', component.options)
    } else {
      api.reload('55737a29', component.options)
    }
    module.hot.accept("./ShareOfShelf.vue?vue&type=template&id=55737a29&scoped=true", function () {
      api.rerender('55737a29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/ShareOfShelf.vue"
export default component.exports